import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientApiService } from '../../core/api/api.service';
import { BaseEntity } from '../models/base-entity';
import { HttpRequest } from '@angular/common/http';

@Injectable()
export class BaseEntityService {

  /**
   * Entity endpoints
   * @type {{root: string}}
   */
  public endpoint: any = {root: '', many: '', search: ''};

  /**
   * Constructor
   * @param {ClientApiService} api
   */
  constructor(protected api: ClientApiService) { }
  /**
   * List of entities
   * @param {{}} options
   * @returns {Observable<BaseEntity[]>}
   */
  public list(options = {}): Observable<BaseEntity[]> {
    return this.api.get(this.endpoint.root, options);
  }

  /**
   * Get entity
   * @param {number} id
   * @param {{}} options
   * @returns {Observable<BaseEntity>}
   */
  public getEntity(id: number | string, options = {}): Observable<BaseEntity> {
    return this.api.get(this.endpoint.root + '/' + id, options);
  }

  /**
   * Create entity
   * @param body
   * @param {{}} options
   * @returns {Observable<BaseEntity>}
   */
  public create(body: any, options = {}): Observable<BaseEntity> {
    return this.api.post(this.endpoint.root, body, options);
  }
  /**
   * Update entity
   * @param {number} id
   * @param body
   * @param {{}} options
   * @returns {Observable<BaseEntity>}
   */
  public update(id: number, body: any, options = {}): Observable<BaseEntity> {
    return this.api.put(this.endpoint.root + '/' + id, body, options);
  }

  /**
   * Remove entity
   * @param {number} id
   * @param {{}} options
   * @returns {Observable<any>}
   */
  public remove(id: number, options = {}): Observable<any> {
    return this.api.delete(this.endpoint.root + '/' + id, options);
  }

  /**
   * Remove many entities
   * @param {number[]} entities
   * @returns {Observable<any>}
   */
  public removeMany(entities: number[], staticParam = false): Observable<any> {
    const endpoint = this.endpoint.many || this.endpoint.root.slice(0, this.endpoint.root.length - 1);
    let methodDelete = (!staticParam) ? this.api.delete.bind(this.api) : this.api.deleteStatic.bind(this.api);
    console.log('base enity', endpoint);
    return methodDelete(endpoint + '/multiple', {body: {entities}});
  }

  /**
   * Custom request
   * @param {HttpRequest} req
   * @returns {Observable<any>}
   */
  public request (req: HttpRequest<any>): Observable<any> {
    return this.api.request(req);
  }

  search(options) {
    const endpoint = this.endpoint.search || this.endpoint.many || this.endpoint.root.slice(0, this.endpoint.root.length - 1);
    return this.api.get(`${endpoint}/search`, options);
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/classes/base-entity-service.ts